import { useState, useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { authService } from '../services/auth.service';

export function ResetPasswordPage() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const token = searchParams.get('token');
  
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);

  useEffect(() => {
    if (!token) {
      setError('Token de recuperación no encontrado. Solicita un nuevo enlace.');
    }
  }, [token]);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    
    if (!token) {
      setError('Token inválido');
      return;
    }

    if (newPassword.length < 6) {
      setError('La contraseña debe tener al menos 6 caracteres');
      return;
    }

    if (newPassword !== confirmPassword) {
      setError('Las contraseñas no coinciden');
      return;
    }

    setIsLoading(true);
    setError('');

    try {
      await authService.resetPassword(token, newPassword);
      setSuccess(true);
      setTimeout(() => {
        navigate('/login');
      }, 3000);
    } catch (err: any) {
      setError(err.message || 'Error al restablecer la contraseña');
    } finally {
      setIsLoading(false);
    }
  };

  // ============================================================
  // PANTALLA DE RESET PASSWORD
  // ============================================================
  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: '#0f172a',
      backgroundImage: 'radial-gradient(ellipse at top, #1a202c 0%, #0f172a 100%)',
      padding: '20px'
    }}>
      <div className="login-container" style={{ maxWidth: '420px', padding: 0 }}>
        <div className="login-box">
          <div className="login-header">
            <img 
              src="/img/logo.png" 
              alt="Gran Arquitectura" 
              className="login-logo"
              style={{ height: '56px', width: 'auto', marginBottom: '16px' }}
            />
            <h1>Restablecer Contraseña</h1>
            <p>Ingresa tu nueva contraseña</p>
          </div>

          {success ? (
            <div style={{ textAlign: 'center', padding: '20px 0' }}>
              <div style={{ 
                fontSize: '48px', 
                marginBottom: '16px'
              }}>✅</div>
              <h3 style={{ color: '#059669', marginBottom: '8px' }}>
                Contraseña actualizada
              </h3>
              <p style={{ color: '#64748b', marginBottom: '16px' }}>
                Tu contraseña se ha actualizado exitosamente.
              </p>
              <p style={{ color: '#94a3b8', fontSize: '14px' }}>
                Redirigiendo al inicio de sesión...
              </p>
            </div>
          ) : (
            <form onSubmit={handleSubmit} className="login-form">
              <div className="form-group">
                <label htmlFor="newPassword">Nueva contraseña</label>
                <input
                  id="newPassword"
                  type="password"
                  required
                  minLength={6}
                  value={newPassword}
                  onChange={(e) => setNewPassword(e.target.value)}
                  placeholder="••••••••"
                  disabled={isLoading || !token}
                  autoFocus
                />
                <span style={{ fontSize: '12px', color: '#94a3b8', marginTop: '4px' }}>
                  Mínimo 6 caracteres
                </span>
              </div>

              <div className="form-group">
                <label htmlFor="confirmPassword">Confirmar contraseña</label>
                <input
                  id="confirmPassword"
                  type="password"
                  required
                  minLength={6}
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  placeholder="••••••••"
                  disabled={isLoading || !token}
                />
              </div>

              {error && (
                <div className="error-message">
                  <span className="error-icon">❌</span>
                  <span>{error}</span>
                </div>
              )}

              <button 
                type="submit" 
                className="btn-login" 
                disabled={isLoading || !token}
              >
                {isLoading ? (
                  <>
                    <span className="spinner"></span>
                    Actualizando...
                  </>
                ) : (
                  'Restablecer Contraseña'
                )}
              </button>

              <div style={{ textAlign: 'center', marginTop: '16px' }}>
                <a href="/login" className="forgot-link">
                  ← Volver al inicio de sesión
                </a>
              </div>

              <div className="login-footer">
                <p>© 2026 Gran Arquitectura. Todos los derechos reservados.</p>
              </div>
            </form>
          )}
        </div>
      </div>
    </div>
  );
}